<template>
    <b-card no-body>
        <b-card-body>
            <b-card bg-variant="light">
                <b-form-row @keyup.enter="load">
                    <lg-form-input v-model="form.descricao" label="Produto:" description="" />
                    <b-col cols="12" class="text-right">
                        <b-button class=" " size="sm" pill variant="primary" style="font-size:9px;" @click="load()">
                            <div>
                                <b-icon icon="search" /> &nbsp;Buscar
                            </div>
                        </b-button>
                        <b-button class="ml-3 mr-2 my-2" size="sm" pill :disabled="isCarrinhoVazio"
                            v-if="temPrivilegioAcessarCarrinho()" variant="primary" style="font-size:9px;"
                            @click="showCarrinho()">
                            <div>
                                <b-icon scale="1" icon="cart" /> Carrinho ({{ carrinho.length }})
                            </div>
                        </b-button>


                        <b-button class="mr-2 my-2" size="sm" style="font-size:9px;" v-if="temPrivilegioAcessarPedido()"
                            @click="showPedido()" pill variant="primary">
                            <div>
                                <b-icon scale="1" icon="plus" /> Pedidos
                            </div>
                        </b-button>
                    </b-col>
                </b-form-row>
                <b-table responsive class="mt-2" small :busy="this.busy" :items="this.records"
                    :fields="this.tableFields" :hover="true" selectable @row-dblclicked="abrirDetalheProduto">
                    <template #empty>
                        <p>Nenhum registro encontrado</p>
                    </template>
                    <template v-slot:cell(situacao)="{ item }">
                        <b-form-checkbox v-model="item.situacao" @change="alteraSituacao(item)" name="check-button"
                            switch size="lg" :value="1" :unchecked-value="0" />
                    </template>
                    <template #table-busy>
                        <div class="text-center text-primary my-2">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                    </template>


                    <template v-slot:cell(imagem)="{ item }">
                        <img :src="convertByteArrayToImage(item.imagem)" alt="Imagem do Produto"
                            style="width: 100px; height: auto;">
                    </template>

                    <template v-slot:cell(action)="{ item }">
                        <lg-button-acoes :actions="actionsBtn" :itemRecord="item"></lg-button-acoes>
                    </template>
                </b-table>
                <div class="row">
                    <div class="h6 col-sm-6" style="display: flex; align-items: center">
                        Página {{ page }} de {{ totalPage }} - {{ total }} registros
                    </div>
                    <div class="col-sm-6">
                        <b-pagination v-model="page" :per-page="perPage" :total-rows="total"></b-pagination>
                    </div>
                </div>
            </b-card>
        </b-card-body>
        <ModalCatalogoConsultaPedidos v-if="showModalConsultaPedido" @fecharModal='fecharModal' :prefix='title'>
        </ModalCatalogoConsultaPedidos>
        <DescricaoDetalhadaProduto v-if="showModalDescricaoDetalhada" @fecharModal='fecharModal' :id="idproduto"
            @adicionarAoCarrinho="adicionarAoCarrinho">
        </DescricaoDetalhadaProduto>
        <CarrinhoCatalogoConsulta v-if='showModalCarrinho' :itens="carrinho" @fecharModal='fecharModalCarrinho'
            @removerItem="removerItem" @limparCarrinho="limparCarrinho" :prefix="prefix + titleSimple + ' > '">
        </CarrinhoCatalogoConsulta>
    </b-card>
</template>

<script>
import ResourceService from "@/core/api/ResourceService"
import LgButtonAcoes from "@/core/components/Form/LgButtonAcoes.vue"
import LgFormInput from "@/core/components/Form/LgFormInput.vue"
import ConfirmMixin from "@/core/mixins/confirm"
import { FormResourceMixin, ListResourceMixin } from "@/core/mixins/resource"
import ModalCatalogoConsultaPedidos from "../../../core/components/Modals/ModalCatalogoConsultaPedidos.vue"
import CarrinhoCatalogoConsulta from "./CarrinhoCatalogoConsulta.vue"
import DescricaoDetalhadaProduto from "./DescricaoDetalhadaProduto.vue"
import verificaPrivilegio from "@/utils/VerificaPrivilegio"
import PrivilegiosEnum from "@/core/utils/PrivilegioEnum"


export default {
    components: {
        LgFormInput,
        LgButtonAcoes,
        ModalCatalogoConsultaPedidos,
        DescricaoDetalhadaProduto,
        CarrinhoCatalogoConsulta
    },
    created() {
    },
    props: {
        imageList: {
            type: Array,
            default: () => [],
        },
        prefix: {
            type: String,
            default: "",
        },
        titleSimple: {
            type: String,
            default: "Consultar Catálogo"
        },
        title: {
            type: Array,
            default: () => ["Consultar Catálogo"],
        },
    },

    data() {
        return {
            showModalDescricaoDetalhada: false,
            showModalConsultaPedido: false,
            showModalCarrinho: false,
            idproduto: null,
            carrinho: [],
            form: {
                foto: null,
                descricao: null,
                apelido: null,
                produto: null,
                numero: null,
                almoxarifado: null,
                situacao: "1",
                bloqueado: "0",
                invisivel: "1",
                imageDataUrl: null,
            },
        }
    },

    mixins: [ListResourceMixin, FormResourceMixin, ConfirmMixin],

    beforeMount() {
        this.$produtoService = new ResourceService(`/api/produto`)
        this.$service = new ResourceService(`/api/catalogoconsulta`)
        this.$fotoService = new ResourceService(`/api/foto`)
    },

    mounted() {
        this.convertByteArrayToImage()
        this.busy = false
    },

    watch: {
        page() {
            this.load()
        },
    },

    computed: {
        isCarrinhoVazio() {
            return this.carrinho.length === 0
        },
        tableFields() {
            return [
                { key: "imagem", label: "Fotos" },
                { key: "produtoCatalogo.apelido", label: "Apelido" },
                { key: "produtoCatalogo.descricao", label: "Descrição" },
            ]
        },
    },

    methods: {
        temPrivilegioAcessarCarrinho() {
            return verificaPrivilegio(PrivilegiosEnum.CATALOGO_PATRIMONIO_ACESSAR_CARRINHO);

        },
        temPrivilegioAcessarPedido() {
            return verificaPrivilegio(PrivilegiosEnum.CATALOGO_PATRIMONIO_ACESSAR_PEDIDOS);

        },

        adicionarAoCarrinho(item) {
            this.carrinho.push(item)
        },
        removerItem(item) {
            this.carrinho = this.carrinho.filter(i => i !== item)
        },
        showCarrinho() {
            this.showModalCarrinho = true
        },
        fecharModalCarrinho() {
            this.showModalCarrinho = false
        },
        limparCarrinho() {
            this.carrinho = []
        },
        convertByteArrayToImage(byteArray) {
            if (!byteArray) return ''
            return `data:image/jpeg;base64,${byteArray}`
        },
        abrirDetalheProduto(item) {
            this.idproduto = item.produtoCatalogo.id
            this.showModalDescricaoDetalhada = true
        },
        fecharModal() {
            this.showModalDescricaoDetalhada = false
            this.showModalConsultaPedido = false
        },
        async load() {
            if (!this.form.descricao || this.form.descricao < 3) {
                this.$notify({
                    type: "warning",
                    message: "Termo pesquisado deve ter no mínimo 3 caracteres!",
                });

                return;
            }


            this.busy = true;

            await this.$loadResource({
                size: this.perPage,
                page: this.page,
                params: this.form,
            })
        },

        async showPedido() {
            this.showModalConsultaPedido = true
        },

        async buscarProduto() {
            const $produtoService = new ResourceService(`/api/produto`)
            const result = await $produtoService.findAll({})
            this.form.produto = result.data.content
        },

        async alteraSituacao(item) {
            const { status } = await this.$service.alteraSituacao(item)

            if (status == 200) {
                this.$notify({
                    type: "success",
                    message: `Registro ${item.situacao ? "Ativado" : "Desativado"
                        } com sucesso!`,
                })
            } else {
                this.$notify({
                    type: "danger",
                    message: `Erro ao ${item.situacao ? "Ativar" : "Desativar"
                        } o registro!`,
                })
                item.situacao = !item.situacao
            }
        },
    }
}
</script>
